module.exports = __webpack_public_path__ + "static/media/yellow.a565674d.ogg";